'use strict';

var Theme = require('../DesignTokens/Theme.js');

var useFormColors = function useFormColors(destructive, disabled) {
  var _palette$error, _palette$primary, _palette$error2, _palette$primary2, _palette$error3, _palette$primary3, _palette$white, _palette$black, _palette$secondary;

  var palette = Theme.theme.palette;
  var disabledColor = palette === null || palette === void 0 ? void 0 : palette.secondary[400];

  if (disabled) {
    return {
      lightColor: disabledColor,
      mainColor: disabledColor,
      darkColor: disabledColor,
      helperColor: disabledColor,
      disabledColor: disabledColor,
      whiteColor: palette.white.primary,
      blackColor: disabledColor
    };
  }

  var lightColor = destructive ? palette === null || palette === void 0 ? void 0 : (_palette$error = palette.error) === null || _palette$error === void 0 ? void 0 : _palette$error.light : palette === null || palette === void 0 ? void 0 : (_palette$primary = palette.primary) === null || _palette$primary === void 0 ? void 0 : _palette$primary.light;
  var mainColor = destructive ? palette === null || palette === void 0 ? void 0 : (_palette$error2 = palette.error) === null || _palette$error2 === void 0 ? void 0 : _palette$error2.main : palette === null || palette === void 0 ? void 0 : (_palette$primary2 = palette.primary) === null || _palette$primary2 === void 0 ? void 0 : _palette$primary2.main;
  var darkColor = destructive ? palette === null || palette === void 0 ? void 0 : (_palette$error3 = palette.error) === null || _palette$error3 === void 0 ? void 0 : _palette$error3.dark : palette === null || palette === void 0 ? void 0 : (_palette$primary3 = palette.primary) === null || _palette$primary3 === void 0 ? void 0 : _palette$primary3.dark;
  var whiteColor = palette === null || palette === void 0 ? void 0 : (_palette$white = palette.white) === null || _palette$white === void 0 ? void 0 : _palette$white.primary;
  var blackColor = palette === null || palette === void 0 ? void 0 : (_palette$black = palette.black) === null || _palette$black === void 0 ? void 0 : _palette$black.primary;
  var helperColor = palette === null || palette === void 0 ? void 0 : (_palette$secondary = palette.secondary) === null || _palette$secondary === void 0 ? void 0 : _palette$secondary.main;
  return {
    lightColor: lightColor,
    mainColor: mainColor,
    darkColor: darkColor,
    helperColor: helperColor,
    disabledColor: disabledColor,
    whiteColor: whiteColor,
    blackColor: blackColor
  };
};

module.exports = useFormColors;
